<template>
  <div>
    <div class="back-img"/>
    <div class="opacity"/>
    <TopMenu
      no-menu
      no-background/>
    <div class="logo">
      <a
        href="http://sqc.ca"
        target="_blank"><img
          src="../../assets/images/SQC_logo_signature_white.svg"
          alt="Syndicat Québécois Construction"
          width="150" ></a>
    </div>
    <div class="reset-password text-center">
      <form
        class="form-reset-password"
        @submit.prevent="submit">
        <p class="baseColor">
          {{ $t("RESET_PASSWORD.INSTRUCTION_TEXT") }}&nbsp;
          <span>
            <i
              variant="primary"
              class="far fa-question-circle pr-2"
              @click="show = !show"/>
          </span>
        </p>
        <password-rules :show="show" />
        <label
          for="inputPassword"
          class="sr-only">{{ $t("RESET_PASSWORD.PASSWORD_PLACEHOLDER") }}</label>
        <input
          id="inputPassword"
          v-model="password"
          :placeholder="$t('RESET_PASSWORD.PASSWORD_PLACEHOLDER')"
          type="password"
          class="form-control"
          required
          autofocus>
        <label
          for="inputConfirmPassword"
          class="sr-only">{{ $t("RESET_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER") }}</label>
        <input
          id="inputConfirmPassword"
          v-model="confirmPassword"
          :placeholder="$t('RESET_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER')"
          type="password"
          class="form-control"
          required>
        <ActionButton
          type="submit"
          class-name="btn btn-lg btn-secondary btn-block mt-3">{{ $t("RESET_PASSWORD.CHANGE_PASSWORD_BUTTON_TEXT") }}</ActionButton>
        <LanguagePicker/>
        <Copyright/>
      </form>
    </div>
  </div>
</template>

<script>
import TopMenu from '@/components/Menu/TopMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import LanguagePicker from '@/components/Utils/LanguagePicker';
import Copyright from '@/components/Utils/Copyright';
import PasswordRules from '@/components/Utils/PasswordRules';

export default {
  name: 'ResetPassword',
  components: {
    ActionButton,
    Copyright,
    LanguagePicker,
    TextLink,
    TopMenu,
    PasswordRules,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      show: false,
    };
  },
  created() {
    if (!this.$route.query.userId || !this.$route.query.code) {
      this.$router.push('/');
    }
  },
  methods: {
    submit() {
      if (this.password !== this.confirmPassword) {
        return this.$store.commit('alerts/setAlert', {
          msg: 'RESET_PASSWORD.PASSWORD_NOT_IDENTICAL',
        });
      }

      return this.$store.dispatch('user/resetPassword', {
        userId: this.$route.query.userId,
        code: this.$route.query.code,
        password: this.password,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.back-img {
  background-image: url("../../assets/images/background_image_login.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-position: center;
}
.opacity {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  top: 0;
  z-index: -1;
}

div {
  &.reset-password {
    min-height: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

.logo {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $primary;
  width: 175px;
  margin-left: auto;
  margin-right: auto;
}

.form-reset-password {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
  i{
      color:$yellow;
  }
}
.form-reset-password .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 20px;
}
.form-reset-password .form-control:focus {
  z-index: 2;
}
.form-reset-password input#inputPassword {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-reset-password input#inputConfirmPassword {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
